export default function saveAsNewRecord(paramData){

    this.rest.post("saveDeletedAsNewRecord", paramData, returnData => {
        const url = `#detail/${paramData.module}/${returnData.message.data}/`
        window.location.replace(url)
    })
}